import Index from '@/vues/posts/index.vue';
import Top from '@/vues/posts/top.vue';
import Search from '@/vues/posts/search.vue';
import Show from '@/vues/posts/show.vue';

export default [
  {
    path: '/',
    name: 'Posts Index',
    component: Index
  },
  {
    path: '/top',
    name: 'Posts Top',
    component: Top
  },
  {
    path: '/search',
    name: 'Posts Search',
    component: Search
  },
  {
    path: '/posts/:id(\\d+)',
    alias: '/posts/:name+-:id(\\d+)',
    name: 'Posts Show',
    component: Show
  }
];
